export function SET_TAGS_NEWS (state, data) {
    state.dataTagsNews = data.tagsNews
}